import Vue from 'vue'
import Router from 'vue-router'
import routes from './routers'
import store from '@/store'
import iView from 'iview'
import { setToken, getToken, canTurnTo, setTitle, getDefaultRouteNameByAccess } from '@/libs/util'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes
  // mode: 'history'
})

const LOGIN_PAGE_NAME = 'login'
const LANDING_PAGE_NAME = 'landing'
const PUBLIC_PAGE_NAMES = [LOGIN_PAGE_NAME, LANDING_PAGE_NAME]

const turnTo = (to, access, next) => {
  if (canTurnTo(to.name, access, routes)) {
    next()
  } else {
    next({ replace: true, name: 'error_401' })
  }
}

const goToDefaultHome = (next) => {
  if (store.state.user.hasGetInfo) {
    const defaultHome = getDefaultRouteNameByAccess(store.state.user.access, routes)
    next({ name: defaultHome })
    return
  }

  store.dispatch('getUserInfo').then(() => {
    const defaultHome = getDefaultRouteNameByAccess(store.state.user.access, routes)
    next({ name: defaultHome })
  }).catch(() => {
    setToken('')
    next({ name: LANDING_PAGE_NAME })
  })
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  const token = getToken()

  if (!token) {
    if (PUBLIC_PAGE_NAMES.includes(to.name)) {
      next()
    } else {
      next({ name: LANDING_PAGE_NAME })
    }
    return
  }

  if (to.name === LOGIN_PAGE_NAME || to.name === LANDING_PAGE_NAME) {
    goToDefaultHome(next)
    return
  }

  if (store.state.user.hasGetInfo) {
    turnTo(to, store.state.user.access, next)
    return
  }

  store.dispatch('getUserInfo').then(() => {
    turnTo(to, store.state.user.access, next)
  }).catch(() => {
    setToken('')
    next({ name: LANDING_PAGE_NAME })
  })
})

router.afterEach(to => {
  setTitle(to, router.app)
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload()
  } else {
    console.log(error)
  }
})

router.addRoute({
  path: '/device-logs',
  name: 'device-logs',
  component: () => import('@/view/strategy_org/device_logs.vue')
})

export default router
